import React from "react";
import { UpdateProfile } from "../../Model/Users";
import { Link } from "react-router-dom";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import Profilemenu from "../Profile_menu/Profilemenu";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { isMobile } from "react-device-detect";
var SVGIcon = "";
var ImageData = "";

SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));

class Enterpincode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      pin1: "",
      pin2: "",
      pin3: "",
      pin4: "",
      IvalidpinMsg: "",
      // verifymsg: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.submitVerifypinForm = this.submitVerifypinForm.bind(this);
  }

  /*------------------Handle Change------------------*/

  handleChange(value1, event) {
    // const fields = this.state.PinField;

    this.setState({
      IvalidpinMsg: "",
    });
    this.setState({ [value1]: event.target.value });
  }

  /*-----------Verify Pin Submit Form--------------*/

  submitVerifypinForm(e) {
    e.preventDefault();
    var postdata = {
      user_email: this.props.data.state.fields.fld_email,
      user_mobile: this.props.data.state.fields.fld_mobile,
      country_code: this.props.data.state.fields.country_code,
      otp:
        this.state.pin1 + this.state.pin2 + this.state.pin3 + this.state.pin4,
      type: this.props.data.state.RequestType,
      verifytype: "mobile",
    };
    UpdateProfile(postdata).then((res) => {
      var VerifyPinResp = JSON.parse(res.data.message);
      if (VerifyPinResp.success == true) {
        this.props.data.popupshow();
        this.setState({
          IvalidpinMsg: VerifyPinResp.message,
        });
      } else {
        //this.props.data.popupshow();
        this.setState({
          IvalidpinMsg: VerifyPinResp.message,
        });
      }
    });
  }

  headerText() {
    return (
      <div className="homeBanner">
        <div className="innerBanner mb-0">
          <div className="title-reset">
            <h1>
              Verification <span className="red"> code</span>
            </h1>
            <div className="reset">
              Please enter the verification code that we have just sent to you
              on your WhatsApp account. The code will be valid for 30 minutes.
            </div>
          </div>
        </div>
      </div>
    );
  }

  backbtn() {
    this.props.navigate("/manage-profile");
  }

  inputfocus = (elmnt) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      const next = elmnt.target.tabIndex - 2;
      if (next > -1) {
        elmnt.target.form.elements[next].focus();
      }
    } else {

      const next = elmnt.target.tabIndex;
      if (next < 4) {
        elmnt.target.form.elements[next].focus();
      }
    }
  };
  /*----------------------Render----------------------*/

  render() {
    /*------Verify Pin Button Enable disable-------*/

    // var Pinstate = this.state.PinField;

    if (
      this.state.pin1 &&
      this.state.pin2 &&
      this.state.pin3 &&
      this.state.pin4
    ) {
      var Button = false;
    } else {
      var Button = true;
    }

    return (
      <>
        <header>
          <div className="mainNav dD-none">
            <div
              onClick={() => {
                this.props.data.backbtn();
              }}
              className="docubayBack white pl-8"
            >
              <img src="img/svg/back.svg" alt="DocuBay" /> {this.props.title}{" "}
              Phone Number
            </div>
            <div className="topQuestion">
              {/*<img src="img/svg/help.svg" alt="help" />*/}
            </div>
          </div>
        </header>
        <main>
          <section className="mb-0 dD-none">{this.headerText()}</section>
          <form
            method="post"
            name="verifypin"
            onSubmit={this.submitVerifypinForm}
            noValidate="novalidate"
          >
            <section style={{ paddingBottom: 45 }} className="dD-none">
              <div className="temp31">
                <div className="temp31Inner">
                  <div className="formField verify-code">
                    <input
                      type="tel"
                      name="pin1"
                      placeholder=""
                      className="text-center"
                      maxLength="1"
                      onKeyDown={this.keyDown}
                      value={this.state.pin1 || ""}
                      onChange={(e) => this.handleChange("pin1", e)}
                      tabIndex="1"
                      onKeyUp={(e) => this.inputfocus(e)}
                    />
                  </div>
                  <div className="formField verify-code">
                    <input
                      type="tel"
                      name="pin2"
                      placeholder=""
                      maxLength="1"
                      className="text-center"
                      value={this.state.pin2 || ""}
                      onChange={(e) => this.handleChange("pin2", e)}
                      tabIndex="2"
                      onKeyUp={(e) => this.inputfocus(e)}
                    />
                  </div>
                  <div className="formField verify-code">
                    <input
                      type="tel"
                      name="pin3"
                      placeholder=""
                      maxLength="1"
                      className="text-center"
                      value={this.state.pin3 || ""}
                      onChange={(e) => this.handleChange("pin3", e)}
                      tabIndex="3"
                      onKeyUp={(e) => this.inputfocus(e)}
                    />
                  </div>
                  <div className="formField verify-code">
                    <input
                      type="tel"
                      name="pin4"
                      placeholder=""
                      maxLength="1"
                      className="text-center"
                      value={this.state.pin4 || ""}
                      onChange={(e) => this.handleChange("pin4", e)}
                      tabIndex="4"
                      onKeyUp={(e) => this.inputfocus(e)}
                    />
                  </div>
                  {this.state.IvalidpinMsg ? (
                    <div className="error error-verifyotp">
                      <img
                        src={process.env.PUBLIC_URL + "img/svg/error.svg"}
                        alt="DocuBay"
                      />
                      <p>{this.state.IvalidpinMsg} </p>
                    </div>
                  ) : null}
                  <div className="formField mt-24 mb-24">
                    <button
                      type="submit"
                      id="sendEnquiryBtn"
                      disabled={Button}
                      className={Button ? "btn-black" : "btn-red"}
                    >
                      Verify
                    </button>
                  </div>
                </div>
                {/* {this.state.verifymsg ? (<div className="temp31-modal-body">
                  <button
                    className="temp31-modal-close temp31-modal-toggle"
                    onClick={() => {
                      this.backbtn();
                    }}
                  >
                    <img
                      src={SVGIcon["promocode-close.svg"]}
                      alt="Docubay"
                    />
                  </button>
                  <img
                    src={ImageData["email.png"]}
                    alt="Docubay"
                    className="imgPass"
                  />
                  <div className="temp31-awesome">
                    <h5>Mobile number changed!</h5>
                    <h6>Your Mobile number has been Verified successfully</h6>
                  </div>
                  <Link
                    to="/"
                    type="submit"
                    id="sendEnquiryBtn"
                    className="btn-white"
                  >
                    Back to Home
                  </Link>
                </div>
                ) : null} */}
              </div>
            </section>
          </form>
        </main>
        <>
          <div className="profile-back-desk dD-block">
            <Link to="/profile">
              <div className="docubayBack white">
                <img src={SVGIcon["back.svg"]} alt="DocuBay" />
              </div>
            </Link>
          </div>
          <main className="setting-main dD-block">
            <section className="mb-0">{this.headerText()}</section>
            <form
              method="post"
              name="verifypin"
              onSubmit={this.submitVerifypinForm}
              noValidate="novalidate"
            >
              <section style={{ paddingBottom: 45 }}>
                <div className="temp31">
                  <div className="temp31Inner">
                    <div className="pinInput">
                      <div className="formField verify-code">
                        <input
                          type="tel"
                          name="pin1"
                          placeholder=""
                          className="text-center"
                          maxLength="1"
                          onKeyDown={this.keyDown}
                          value={this.state.pin1 || ""}
                          onChange={(e) => this.handleChange("pin1", e)}
                          tabIndex="1"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                      <div className="formField verify-code">
                        <input
                          type="tel"
                          name="pin2"
                          placeholder=""
                          maxLength="1"
                          className="text-center"
                          value={this.state.pin2 || ""}
                          onChange={(e) => this.handleChange("pin2", e)}
                          tabIndex="2"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                      <div className="formField verify-code">
                        <input
                          type="tel"
                          name="pin3"
                          placeholder=""
                          maxLength="1"
                          className="text-center"
                          value={this.state.pin3 || ""}
                          onChange={(e) => this.handleChange("pin3", e)}
                          tabIndex="3"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                      <div className="formField verify-code">
                        <input
                          type="tel"
                          name="pin4"
                          placeholder=""
                          maxLength="1"
                          className="text-center"
                          value={this.state.pin4 || ""}
                          onChange={(e) => this.handleChange("pin4", e)}
                          tabIndex="4"
                          onKeyUp={(e) => this.inputfocus(e)}
                        />
                      </div>
                    </div>
                    {this.state.IvalidpinMsg ? (
                      <div className="error error-verifyotp">
                        <img
                          src={process.env.PUBLIC_URL + "img/svg/error.svg"}
                          alt="DocuBay"
                        />
                        <p>{this.state.IvalidpinMsg} </p>
                      </div>
                    ) : null}
                    <div className="formField mt-24 mb-24">
                      <button
                        type="submit"
                        id="sendEnquiryBtn"
                        disabled={Button}
                        className={Button ? "btn-black" : "btn-red"}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                </div>
              </section>
            </form>
          </main>
        </>
        {isMobile ? (
          <Mobilemenu active="5" />
        ) : (
          <Profilemenu
            versioncheck={this.state.VirsionCheckData}
            profile={this.state.ProfileData}
          />
        )}
      </>
    );
  }
}
export default Enterpincode;
